import { Numeric6CircleIcon } from './Numeric6CircleIcon';

/**
 * author: Contributors
 * id E15A2826-796D-439A-9A10-4F068C76C6FC
 * name numeric-6-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-6-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericSixCircleIcon = Numeric6CircleIcon;
export default NumericSixCircleIcon